import { render, staticRenderFns } from "./settingpsb.vue?vue&type=template&id=d87e286c&"
import script from "./settingpsb.vue?vue&type=script&lang=js&"
export * from "./settingpsb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports